import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";
import { UncontrolledTooltip } from 'reactstrap';

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comparablePrefectures: null,
      total: 0
    };

    this.handleGeoClick.bind(this);
  }

  componentDidMount() {
    const { index, tier } = this.props;

    if(index) {
      fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}`)
        .then((resp) => resp.json())
        .then((respJson) => {
          this.setState({
            comparablePrefectures: respJson.prefectures,
            total: respJson.total
          }); 
        });
    }
  }

  componentDidUpdate(prevProps) {
    const { index, tier } = this.props; 

    if(index && index !== prevProps.index) {
      fetch(`/api/find_comparable_markets/comparable_markets/tier/${tier}/${index}`)
        .then((resp) => resp.json())
        .then((respJson) => {
          this.setState({
            comparablePrefectures: respJson.prefectures,
            total: respJson.total
          }); 
        });
    }
  }

  getColor(province, geoName) {
    const { comparablePrefectures } = this.state; 
    let color = "#ECEFF1";

    comparablePrefectures.forEach((prefecture) => {
      if(this.props.province && geoName === this.props.prefecture.attributes.name && province === this.props.province.attributes.name) {
        color = "#DC3545";
      } else if(prefecture.name === geoName && prefecture.province === province) {
        color = "#29A645";
      } 
    });

    return color;
  }

  handleGeoClick(geoObj, province) {
    const { tier, prefecture } = this.props;

    fetch('/api/prefectures?filter[name]=' + encodeURIComponent(geoObj.name)).then((resp) => resp.json())
      .then((respJson) => {
        respJson.data.forEach((item) => {
          fetch(item.relationships.province.links.related).then((resp) => resp.json())
            .then((respJson) => {
              if(respJson.data.attributes.name === province) {
                window.location.href = "/find_comparable_markets/tier/" + tier +
                  "/prefecture/" + prefecture.id + "/comparable_prefecture/" + item.id;
              }
            });
        });
      });
  }

  render() {
    const { comparablePrefectures, total } = this.state;
    const { prefecture } = this.props;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          There are {total} prefectures that are comparable to { prefecture ? prefecture.attributes.name : null}.
        </CardHeader>
        <CardBody className="p-0">
          <div className="w-100 my-0 mx-auto">
            <ComposableMap
              projectionConfig={{
                scale: 1000,
                rotation: [-11,0,0],
              }}
              width={980}
              height={650}
              style={{
                width: "100%",
                height: "auto",
              }}
              >
              <ZoomableGroup center={[105,37]} disablePanning>
                <Geographies geography={"/geographies/ChinaAllPrefectures.json"} disableOptimization>
                  {(geographies, projection) => geographies.map((geography, i) => {
                    if(geography.id !== "ATA") {
                      let defaultFill = "#ECEFF1";

                      if(geography.properties.notAvailable) {
                        return (
                          <Geography
                            key={i}
                            id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                            geography={geography}
                            projection={projection}
                            style={{
                              default: {
                                fill: defaultFill,
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                opacity: 0.3,
                                outline: "none",
                              },
                              hover: {
                                fill: defaultFill,
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                opacity: 0.3,
                                outline: "none",
                              },
                              pressed: {
                                fill: defaultFill,
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                opacity: 0.3,
                                outline: "none",
                              },
                            }}
                          >
                            <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                              {geography.properties.name} (Coming Soon)
                            </UncontrolledTooltip>
                          </Geography>
                        ); 
                      } else {
                        return (
                          <Geography
                            key={i}
                            id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                            geography={geography}
                            projection={projection}
                            onClick={(geo) => this.handleGeoClick(geo.properties, geo.properties.province)}
                            style={{
                              default: {
                                fill: comparablePrefectures ? this.getColor(geography.properties.province, geography.properties.name) : defaultFill,
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                              hover: {
                                fill: "#215796",
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                              pressed: {
                                fill: "#e25241",
                                stroke: "#215796",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                            }}
                          >
                            <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                              {geography.properties.name}
                            </UncontrolledTooltip>
                          </Geography>
                        ); 
                      }
                    } 
                  })}
                </Geographies>
              </ZoomableGroup>
            </ComposableMap>
          </div>
        </CardBody>
      </Card>
    ); 
  }
}

export default Map;
